/**
 * Messages API
 * 
 * Handles club chat and messaging functionality.
 */

import { apiGet, apiPost, UserLevel, SubscriptionLevel } from '../api';

export interface Message {
  id: string;
  club_id: string;
  user_id: string;
  user_name: string;
  user_level: UserLevel;
  subscription_level: SubscriptionLevel | null;
  profile_image_url: string | null;
  club_role: string;
  body: string;
  image_url?: string;
  image_urls?: string[] | null;
  created_at: number;
}

export interface SendMessagePayload {
  body: string;
  image_url?: string;
  image_urls?: string[];
}

export const messagesApi = {
  /**
   * Get messages for a club
   * GET /clubs/:clubId/messages?limit=50&before=timestamp
   */
  getClubMessages: (clubId: string, limit: number = 50, before?: number) => {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (before !== undefined) {
      params.append('before', before.toString());
    }
    return apiGet<Message[]>(`/clubs/${clubId}/messages?${params.toString()}`);
  },

  /**
   * Send message to club
   * POST /clubs/:clubId/messages
   */
  sendMessage: (clubId: string, payload: SendMessagePayload) => 
    apiPost<{ message: Message }>(`/clubs/${clubId}/messages`, payload),
};
